import { Card } from "./ui/card";
import { CheckCircle2 } from "lucide-react";

interface ServicesListProps {
  service: {
    name: string;
    service_list: string[];
    is_emergency: boolean;
  };
  cityName?: string;
}

export const ServicesList = ({ service, cityName = "Long Island" }: ServicesListProps) => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">
              Our {service.name} in {cityName}
            </h2>
            <p className="text-xl text-muted-foreground">
              {service.is_emergency 
                ? "Available 24/7 for urgent repairs and emergency situations"
                : "Professional services backed by decades of experience"}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-12">
            {service.service_list.map((item, index) => (
              <Card key={index} className="p-6 hover:shadow-lg transition-shadow">
                <div className="flex items-start gap-4">
                  <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-lg mb-2">{item}</h3>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {service.is_emergency && (
            <Card className="p-8 bg-red-50 dark:bg-red-950 border-red-200 dark:border-red-800">
              <div className="text-center">
                <h3 className="text-2xl font-bold mb-4 text-red-900 dark:text-red-100">
                  Emergency Service Available 24/7
                </h3>
                <p className="text-red-800 dark:text-red-200 mb-4">
                  Don't wait! Our emergency response team is standing by to help you with urgent {service.name.toLowerCase()} needs in {cityName}.
                </p>
                <p className="text-lg font-semibold text-red-900 dark:text-red-100">
                  Call now for immediate assistance!
                </p>
              </div>
            </Card>
          )}

          <div className="mt-12 text-center">
            <p className="text-lg text-muted-foreground">
              Serving {cityName} and surrounding areas with expert {service.name.toLowerCase()}. 
              Licensed, insured, and committed to quality workmanship since 2007.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
